import { Box, IconButton, IconButtonProps, Stack, Typography } from '@mui/material';

type RoundedButtonProps = IconButtonProps & {
  text: string;
  iconBackgroundColor?: string;
  iconColor?: string;
  icon: React.ReactNode;
  href?: string;
};

const RoundedButton = ({ text, href, icon, sx, ...rest }: RoundedButtonProps) => {
  return (
    <Stack alignItems="center" spacing={0.5}>
      <Box
        sx={{
          width: 48,
          height: 48,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <IconButton
          component="a"
          href={href}
          {...rest}
          sx={{
            ...sx,
            borderRadius: '50%',
            boxShadow: '0px 2px 6px rgba(0,0,0,0.2)',
          }}
        >
          {icon}
        </IconButton>
      </Box>
      <Typography variant="caption" color="text.secondary" align="center" sx={{ maxWidth: 64 }}>
        {text}
      </Typography>
    </Stack>
  );
};

export default RoundedButton;
